import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import GetIcon from "../../../../utils/Icon";
import { useGetAllAccountsQuery } from "../../../../store/api/itemtaxapi"
const Table = ({ selectedTaxAccounts }) => {
  const [taxOptions, setTaxOptions] = useState([]);

  const createNewRow = () => ({
    tax: "",
    tax_rate: ""
  });
  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showDropdownIndex, setShowDropdownIndex] = useState(null);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const { data: taxData } = useGetAllAccountsQuery();
  useEffect(() => {
    if (taxData?.message) {
      const updatedData = taxData?.message.map((item) => ({
        name: item.value,
        id: item.name
      }));
      setTaxOptions(updatedData);
    }
  }, [taxData]);
  useEffect(() => {
    if (selectedTaxAccounts && selectedTaxAccounts.length > 0) {
      const initialRows = selectedTaxAccounts.map(account => ({
        tax: account.tax_type,
        tax_rate: account.tax_rate
      }));
      setRows(initialRows.length > 0 ? initialRows : [createNewRow()]);
    } else {
      setRows([createNewRow()]);
    }
  }, [selectedTaxAccounts]);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rows.map((_, index) => index));
    } else {
      setSelectedRows([]);
    }
  };
  const toggleRowSelection = (index) => {
    setSelectedRows(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };
  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  const handleAddRow = () => {
    setRows([...rows, createNewRow()]);
    const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };
  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };
  const handleSelectTax = (rowIndex, selectedItem) => {
    const updatedRows = [...rows];
    updatedRows[rowIndex].tax = selectedItem.name;
    setRows(updatedRows);
    setShowDropdownIndex(null);
  };
  useEffect(() => {
    const filtered = rows
      .filter(row => row.tax && row.tax_rate)
      .map(row => ({
        tax_type: row.tax,
        tax_rate: row.tax_rate
      }));
    const isDifferent = JSON.stringify(filtered) !== JSON.stringify([]);
    if (isDifferent) {
    }
  }, [rows]);
  return (
    <div className="table-container">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
            <th style={{ width: '350px' }}>Tax</th>
            <th style={{ width: '350px' }}>Tax Rate</th>
            
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            const showTaxDropdown = showDropdownIndex === globalIndex && focusedCell.field === 'tax';
            return (
              <tr key={globalIndex} style={{ height: '30px' }}>
             <td style={{ textAlign: "center" }}><span style={{ fontSize: '0.8rem' }}
                                >{globalIndex + 1}</span></td>
                <td className="p-0 position-relative">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    disabled
                    value={row.tax}
                    style={{ fontSize: '0.8rem', textAlign: 'center' }}
                    onFocus={() => {
                      setShowDropdownIndex(globalIndex);
                      setFocusedCell({ rowIndex: globalIndex, field: 'tax' });
                    }}
                    onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                    onChange={(e) => updateRow(globalIndex, "tax", e.target.value)}
                  />
                  {showTaxDropdown && (
                    <div
                      ref={dropdownRef}
                      className="dropdown-menu show"
                      style={{
                        width: '100%',
                        maxHeight: '200px',
                        overflowY: 'auto'
                      }}
                    >
                      {taxOptions
                        .filter(t => t.name.toLowerCase().includes(row.tax?.toLowerCase()))
                        .map((tax) => (
                          <button
                            key={tax.id}
                            className="dropdown-item"
                            type="button"
                            onClick={() => handleSelectTax(globalIndex, tax)}
                          >
                            {tax.name}
                          </button>
                        ))}
                    </div>
                  )}
                </td>
                <td className="p-0">
                  <input
                    type="number"
                    disabled
                    className="form-control tableinput noborder"
                    value={row.tax_rate}
                    style={{ fontSize: '0.8rem', textAlign: 'center' }}
                    onChange={(e) =>
                      updateRow(globalIndex, "tax_rate", parseFloat(e.target.value) || 0)
                    }
                  />
                </td>
                
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
        </div>
        {rows.length > 10 && (
          <>
            <div className="d-flex align-items-center centerpagination">
              <Pagination
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                pageSize={rowsPerPage}
                totalrecords={rows.length}
              />
            </div>
            <div className="d-flex">
              <span className="px-2" style={{ color: '#270B79' }}>
                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Table;